
export const BEGIN_ACTION_MASTERDATA = 'BEGIN_ACTION_MASTERDATA';
export const END_ACTION_MASTERDATA = "END_ACTION_MASTERDATA";